import {
  applyMiddleware,
  compose,
  createStore,
  Middleware,
  Store,
} from 'redux';
import createSagaMiddleware, { Task } from 'redux-saga';
import createRootReducer from './rootReducer';
import { navigationMiddleware } from './navigation/middleware';
import { rootSaga } from './rootSaga';
import { StoreState } from './types';

type StoreParams = {
  initialState?: StoreState;
  middleware?: Middleware[];
};

export interface ExtendedStore extends Store<Partial<StoreState>> {
  runSaga: (appSaga: typeof rootSaga) => Task;
}

export const configureStore = ({ initialState, middleware = [] }: StoreParams): ExtendedStore => {
  const devtools =
    typeof window !== 'undefined' &&
    typeof window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ === 'function' &&
    window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({ actionsDenylist: [] });

  const composeEnhancers = devtools || compose;

  const sagaMiddleware = createSagaMiddleware();
  const ehnancers = [...middleware, navigationMiddleware, sagaMiddleware];

  const store = createStore(
    createRootReducer,
    initialState,
    composeEnhancers(applyMiddleware(...ehnancers))
  );

  if (process.env.NODE_ENV !== 'production') {
    if (module.hot) {
      module.hot.accept('./rootReducer', () =>
        store.replaceReducer(require('./rootReducer').default)
      );
    }
  }

  return {
    ...store,
    runSaga: sagaMiddleware.run,
  };
};

export default configureStore;
